var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Cartesian2, SceneTransforms, ScreenSpaceEventType, } from "cesium";
import { ConstructionState, } from "../../site/trench/earthbrain-trench";
import { AddControlPointAtIndexCommandOnTrench, AddControlPointOnTrenchCommand, RemovePointCommandForTrench, UpdateHorizontalAlignmentTypeCommand, UpdatePointPositionCommandForTrench, } from "./trench-commands";
import { CESIUM_PICKABLE_ENTITY } from "../../types";
import { PositionReference, checkPositionWrtToTileset, } from "../../utilities/local-utilities";
import { Activity } from "../../utilities/activity-logger";
import { CesiumPointSelectorType, } from "../../cesium-utils/point-selector/point-selector";
import { getMarkerDistanceById } from "../../site/alignment/section-marker-resolver";
import { SectionSelectionController } from "../alignment/section-selection-controller";
import { hasMovedPastClickThreshold } from "../alignment/control-point-click";
function isEditable() {
    const retVal = (target, key, descriptor) => {
        const original = descriptor.value;
        descriptor.value = function (...args) {
            const trenchEditHandler = this;
            if (trenchEditHandler.trenchUnderEdit) {
                return original.apply(this, args);
            }
        };
        return descriptor;
    };
    return retVal;
}
export class TrenchEditHandler {
    _callback;
    _trenchUnderEdit;
    _viewer;
    _preview;
    _handler;
    _commandManager;
    _cesiumPicker;
    _cesiumPointSelector;
    _rayCastPointSelector;
    _site;
    _cesiumViewer;
    _sectionSelection;
    _controlPointDragStartPosition;
    _hasShownControlPointDragPreview = false;
    // private _trenchExtensionFuncHandler: any;
    _mouseMoveDebounce = undefined;
    /** true の間は getPointOnMousePos が進行中 */
    _isControlPointMoveInProgress = false;
    /** MOUSE_MOVE で受け取った最新イベント。処理完了後にこの値で次の処理を開始する */
    _pendingControlPointMoveEvent = undefined;
    /** LEFT_UP 時に true にし、進行中の処理結果を破棄する */
    _controlPointMoveCancelled = false;
    /** fire-and-forget で実行中の UpdatePointPositionCommandForTrench の Promise */
    _pendingCommandPromise = undefined;
    _isTrenchExtension;
    get sectionPlaneDistanceFromStart() {
        return this._sectionSelection?.state.distFromStartPoint ?? 0;
    }
    get trenchUnderEdit() {
        return this._trenchUnderEdit;
    }
    get cesiumViewer() {
        return this._cesiumViewer;
    }
    get isTrenchExtension() {
        return this._isTrenchExtension;
    }
    constructor(args, cesiumViewer) {
        this._site = args.site;
        this._viewer = args.viewer;
        this._preview = args.preview;
        this._handler = args.handler;
        this._commandManager = args.commandManger;
        this._cesiumPicker = args.cesiumPicker;
        this._isTrenchExtension = false;
        this._cesiumPointSelector =
            args.cesiumPointSelectorFactory.getPointSelector(CesiumPointSelectorType.PriorityBased);
        this._rayCastPointSelector =
            args.cesiumPointSelectorFactory.getPointSelector(CesiumPointSelectorType.RayCastBased);
        this._cesiumViewer = cesiumViewer;
    }
    start(trench, callback) {
        this._callback = callback;
        this._trenchUnderEdit = trench;
        this._trenchUnderEdit.constructionState = ConstructionState.UNDER_EDIT;
        this._commandManager.clear();
        this._isTrenchExtension = false;
        trench.fitToTrench();
        this._sectionSelection = new SectionSelectionController({
            viewer: this._viewer,
            site: this._site,
            host: trench,
            tracksUnnamedPviByRatio: false,
            activity: Activity.TRENCH_SECTION_PLANE_UPDATED,
            onChange: (distance3d, label) => this._callback.onProgress?.(trench.id, distance3d, label),
        });
        // this._trenchExtensionFuncHandler = this._trenchExtensionOnShiftT.bind(this);
        // document.addEventListener("keydown", this._trenchExtensionFuncHandler);
        this._callback.onStart();
    }
    end() {
        this._commandManager.clear();
        this._sectionSelection?.dispose();
        this._sectionSelection = undefined;
        this._handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE);
        this._preview.setSphereVisibility(false);
        this._preview.setLineVisibility(false);
        this._preview.setVerticalLineEntityVisibility(false);
        this._isTrenchExtension = false;
        this._preview.setLinePosition([]);
        // this._trenchExtensionFuncHandler &&
        // 	document.removeEventListener("keydown", this._trenchExtensionFuncHandler);
        this._trenchUnderEdit.constructionState = ConstructionState.READY;
        this._trenchUnderEdit = undefined;
    }
    cancel() {
        //To Do All changes should be undone
        this.end();
    }
    // @isEditable()
    // public undo() {
    //   // Section plan should not be created for any trench operation
    //   this._commandManager.undo(this._cesiumViewer);
    //   this.updateSectionPlaneWith2DViews(this._sectionPlaneData.distFromStartPoint);
    //   // this._updatePreview();
    //   this._viewer.scene.requestRender();
    // }
    // @isEditable()
    // public redo() {
    //   this._commandManager.redo(this._cesiumViewer);
    //   this.updateSectionPlaneWith2DViews(this._sectionPlaneData.distFromStartPoint);
    //   this._viewer.scene.requestRender();
    // }
    // @isEditable()
    // public trenchExtension() {
    // 	this._preview.setSphereVisibility(true);
    // 	this._preview.setLineVisibility(true);
    // 	this._isTrenchExtension = true;
    // 	this._handler.setInputAction(
    // 		this._debunceHandlerForSphereMovement.bind(this),
    // 		ScreenSpaceEventType.MOUSE_MOVE,
    // 	);
    // }
    removeControlPoint(controlPointId) {
        const isControlPointRemovable = this._trenchUnderEdit.isControlPointRemovable(controlPointId);
        //Restricting user from deleting last 2 points of the trench while editing because we need atleast 2 points to create trench.
        // Also restricting the removal of first & last control point
        if (this._trenchUnderEdit.controlPointLength > 2 &&
            isControlPointRemovable) {
            this._commandManager.action(new RemovePointCommandForTrench(this._trenchUnderEdit, controlPointId, this._getCallbackForCommands()), this._cesiumViewer);
        }
    }
    updateHorizontalAlignmentType(horizontalAlignmentType) {
        this._commandManager.action(new UpdateHorizontalAlignmentTypeCommand(this._trenchUnderEdit, horizontalAlignmentType, this._getCallbackForCommands()), this._cesiumViewer);
    }
    /**
     * This Function will let you add a new control point in middle from the control point on which this function is called and the previous control point
     * @param trenchID unique ID of the trench
     */
    addControlPointOnTrench(controlPointId) {
        this._commandManager.action(new AddControlPointOnTrenchCommand(this._trenchUnderEdit, controlPointId, this._getCallbackForCommands()), this._cesiumViewer);
    }
    /**
     * This Function will let you add a new control point in middle from the control point on which this functon is called and the previous control point
     * @param trenchID unique ID of the trench
     */
    addControlPointOnTrenchSegment(segmentId, localPoint) {
        const segIndex = this._trenchUnderEdit
            .getTrenchSegments()
            .findIndex((seg) => seg.id === segmentId);
        if (segIndex !== -1) {
            this._commandManager.action(new AddControlPointAtIndexCommandOnTrench(this._trenchUnderEdit, segIndex + 1, localPoint, this._getCallbackForCommands()), this._cesiumViewer);
            this._sectionSelection?.refresh();
        }
    }
    /**
     * This Function will let you add a new control point on the given point on the center line
     * @param trenchID unique ID of the trench
     * @param localPoint point on center line of the trench
     * @param callback TrenchEditCallback
     */
    addControlPointOnCenterLine(localPoint) {
        const closestPoint = this._trenchUnderEdit.getClosestPointInfoOnPath(localPoint);
        if (closestPoint.ipIndex !== -1) {
            this._commandManager.action(new AddControlPointAtIndexCommandOnTrench(this._trenchUnderEdit, closestPoint.ipIndex + 1, closestPoint.point, this._getCallbackForCommands()), this._cesiumViewer);
            this._sectionSelection?.refresh();
        }
    }
    /** Selects the section identified by `anchor`, which also decides how it is tracked across edits. */
    selectSection(anchor) {
        this._sectionSelection?.select(anchor);
    }
    /** Selects the section for a longitudinal-view click. */
    selectSectionHit(hit) {
        this._sectionSelection?.selectHit(hit);
    }
    refreshSectionSelection() {
        this._sectionSelection?.refresh();
    }
    updateCtrlPointCordiOnTrench(controlPointID, point) {
        if (point) {
            this._site.convertPointsToLocalSpace([point]).then((arr) => {
                const localPos = arr[0];
                const windowCoordinates = SceneTransforms.worldToWindowCoordinates(this._viewer.scene, point);
                const pickedInfo = this._cesiumPicker.getPickablePickedInfo(windowCoordinates);
                this._commandManager.action(new UpdatePointPositionCommandForTrench(this._trenchUnderEdit, { position: point, info: pickedInfo, localPosition: localPos }, controlPointID, this._getCallbackForCommands()), this._cesiumViewer);
                this._sectionSelection?.refresh();
            });
        }
    }
    // @isEditable()
    // public updateSlopeBreaksFromLongitudinalView(slopeBreaks: ISlopeBreak[]): boolean {
    //   // const position = this._trenchUnderEdit.getPositionAtDistanceFromGivenPoint(
    //   //   data.index,
    //   //   data.length,
    //   //   data.height
    //   // );
    //   // const slopeBreak:ISlopeBreak = {
    //   //   percentage: data.length,
    //   //   height: data.height
    //   // }
    //   if (slopeBreaks && slopeBreaks.length > 0) {
    //     this._commandManager.action(new UpdateTrenchSlopeBreaksInLongitudinalView(this._trenchUnderEdit, slopeBreaks, this._getCallbackForCommands()), this._cesiumViewer);
    //     return true;
    //   } else {
    //     this.raiseEventInvalidCtrlPtForTrench(this._trenchUnderEdit.id);
    //     return false;
    //   }
    // }
    /**
     * This function will return Trench ID and Trench point ID
     * @param x screen coordinate
     * @param y screen coordinate
     */
    async pickPathAndPoint(x, y) {
        const result = {
            pathId: undefined,
            entityId: undefined,
            type: undefined,
            entity: undefined,
            position: undefined,
        };
        const posToPick = new Cartesian2(x, y);
        const pickedEntity = this._cesiumPicker.getPickablePickedInfo(posToPick);
        if (pickedEntity) {
            result.pathId = pickedEntity.owner?.id;
            result.entityId = pickedEntity.entity?.id;
            result.type = pickedEntity.pickableType;
            result.entity = pickedEntity.entity;
            result.position = undefined;
            // Use raycast against trench geometry for accurate position
            const clickedPoint = await this._rayCastPointSelector.getPointOnMousePos(posToPick, this._trenchUnderEdit);
            if (clickedPoint) {
                const [localPosition] = await this._site.convertPointsToLocalSpace([
                    clickedPoint,
                ]);
                result.position = [localPosition.x, localPosition.y, localPosition.z];
            }
        }
        return result;
    }
    _getCallbackForCommands() {
        return async () => {
            this._sectionSelection?.refresh();
            // await this._trenchUnderEdit.centerLineLink?.updateIfLinked(this._site);
        };
    }
    raiseEventInvalidCtrlPtForTrench(trenchId) {
        const event = new CustomEvent("invalidControlPointForTrench", {
            detail: { trenchId, type: 7 },
        });
        window.dispatchEvent(event);
    }
    async pickControlPoint(click) {
        // Wait for any pending command to finish to avoid Worker WebSocket queue contention
        if (this._pendingCommandPromise) {
            await this._pendingCommandPromise;
        }
        const pickModel = this._viewer.scene.pick(click.position);
        if (pickModel && pickModel.id) {
            // Finding which path has been clicked
            const selectedPathID = this._site
                .getTrenches()
                .find((p) => p.pickEntity(pickModel.id).entity !== undefined);
            if (selectedPathID && pickModel.id.name === "sphereEntity") {
                if (this._trenchUnderEdit.id === selectedPathID.id) {
                    // Storing the ID of the control point
                    const controlPointID = pickModel.id.id;
                    this._controlPointDragStartPosition = Cartesian2.clone(click.position);
                    this._hasShownControlPointDragPreview = false;
                    this._handler.setInputAction(this._controlPointPosUpdate.bind(this, controlPointID), ScreenSpaceEventType.LEFT_UP);
                    this._handler.setInputAction(this._throttledControlPointMove.bind(this), ScreenSpaceEventType.MOUSE_MOVE);
                    // Now need to disable the camera
                    this._viewer.scene.screenSpaceCameraController.enableRotate = false;
                }
            }
            else if (pickModel.id.pickInfo?.pickableType ===
                CESIUM_PICKABLE_ENTITY.ALIGNMENT_POINT) {
                this._sectionSelection?.selectPickedPoint(pickModel.id.id);
            }
        }
    }
    // private _trenchExtensionOnShiftT(event: KeyboardEvent) {
    // 	if (event.key.toLowerCase() === "t" && event.shiftKey) {
    // 		this.trenchExtension();
    // 	}
    // }
    async _controlPointPosUpdate(controlPointID, clickEvent) {
        // Cancel in-progress move processing
        this._controlPointMoveCancelled = true;
        this._pendingControlPointMoveEvent = undefined;
        const isClick = !hasMovedPastClickThreshold(this._controlPointDragStartPosition, clickEvent.position);
        if (isClick) {
            if (getMarkerDistanceById(this._trenchUnderEdit.alignment, controlPointID) !== undefined) {
                this.selectSection({ type: "point", pointId: controlPointID });
            }
        }
        else {
            // const cartesian = await this._cesiumPointSelector.getPointOnMousePos(
            // 	clickEvent.position,
            // 	true,
            // );
            const cartesian = await this._cesiumPointSelector.getPointOnMousePos(clickEvent.position);
            if (cartesian) {
                this._site.convertPointsToLocalSpace([cartesian]).then((arr) => {
                    const localPos = arr[0];
                    const positionRef = checkPositionWrtToTileset(localPos, this._trenchUnderEdit.associatedTerrain);
                    if (positionRef !== PositionReference.OUTSIDE) {
                        const pickedInfo = this._cesiumPicker.getPickablePickedInfo(clickEvent.position);
                        this._viewer.scene.screenSpaceCameraController.enableRotate = true;
                        const commandPromise = this._commandManager.action(new UpdatePointPositionCommandForTrench(this._trenchUnderEdit, {
                            position: cartesian,
                            info: pickedInfo,
                            localPosition: localPos,
                        }, controlPointID, this._getCallbackForCommands()), this._cesiumViewer);
                        this._pendingCommandPromise = commandPromise;
                        commandPromise.finally(() => {
                            if (this._pendingCommandPromise === commandPromise) {
                                this._pendingCommandPromise = undefined;
                            }
                        });
                    }
                    else {
                        this.raiseEventInvalidCtrlPtForTrench(this._trenchUnderEdit.id);
                    }
                });
            }
        }
        this._controlPointDragStartPosition = undefined;
        this._handler.removeInputAction(ScreenSpaceEventType.LEFT_UP);
        this._handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE);
        // Now need to enable the camera
        this._viewer.scene.screenSpaceCameraController.enableRotate = true;
        this._preview.setSphereVisibility(false);
        // Reset for next drag
        this._controlPointMoveCancelled = false;
        this._isControlPointMoveInProgress = false;
    }
    async _controlPointMove(event) {
        // const pos = await this._cesiumPointSelector.getPointOnMousePos(event.endPosition, true);
        const endPosition = event.endPosition;
        const pos = await this._cesiumPointSelector.getPointOnMousePos(endPosition);
        if (this._controlPointMoveCancelled || !this._controlPointDragStartPosition)
            return;
        if (pos) {
            if (!this._hasShownControlPointDragPreview &&
                hasMovedPastClickThreshold(this._controlPointDragStartPosition, endPosition)) {
                this._preview.setSphereVisibility(true);
                this._preview.createVerticalLineEntityOnSphere();
                this._hasShownControlPointDragPreview = true;
            }
            this._preview.setSpherePosition(pos);
            this._viewer.scene.requestRender();
        }
    }
    _throttledControlPointMove(event) {
        this._pendingControlPointMoveEvent = event;
        if (this._isControlPointMoveInProgress) {
            return;
        }
        this._processNextControlPointMove();
    }
    async _processNextControlPointMove() {
        this._isControlPointMoveInProgress = true;
        while (this._pendingControlPointMoveEvent !== undefined) {
            if (this._controlPointMoveCancelled) {
                break;
            }
            const event = this._pendingControlPointMoveEvent;
            this._pendingControlPointMoveEvent = undefined;
            await this._controlPointMove(event);
        }
        this._isControlPointMoveInProgress = false;
    }
}
__decorate([
    isEditable()
], TrenchEditHandler.prototype, "end", null);
__decorate([
    isEditable()
], TrenchEditHandler.prototype, "cancel", null);
__decorate([
    isEditable()
], TrenchEditHandler.prototype, "removeControlPoint", null);
__decorate([
    isEditable()
], TrenchEditHandler.prototype, "updateHorizontalAlignmentType", null);
__decorate([
    isEditable()
], TrenchEditHandler.prototype, "addControlPointOnTrench", null);
__decorate([
    isEditable()
], TrenchEditHandler.prototype, "addControlPointOnTrenchSegment", null);
__decorate([
    isEditable()
], TrenchEditHandler.prototype, "addControlPointOnCenterLine", null);
__decorate([
    isEditable()
], TrenchEditHandler.prototype, "selectSection", null);
__decorate([
    isEditable()
], TrenchEditHandler.prototype, "refreshSectionSelection", null);
__decorate([
    isEditable()
], TrenchEditHandler.prototype, "updateCtrlPointCordiOnTrench", null);
//# sourceMappingURL=trench-edit-handler.js.map